 
<template>
  <div class="basic-p-drawer drawer-patientmanage" v-if="drawer" style="padding-top:20px">
    <div class="aside" style="height:100%">
      <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">
        <!-- 预览状态 -->
        <el-form :model="ruleForm1"  label-width="140px" size="mini" label-position="left" v-if="!isEdit"
          class="no-edit">
          <!-- <el-form-item label="治疗阶段:">
            <p>{{ ruleForm1.therapyStage }}</p>
          </el-form-item> -->

          <el-form-item label="当前病种:">
            <p>{{ ruleForm1.diseaseName }}</p>
          </el-form-item>
          <el-form-item label="治疗阶段:">
            <p>{{ ruleForm1.therapyStage }}</p>
            <p>
              {{ ruleForm1.firstTherapyStageName
              }}<span v-if="ruleForm1.secondTherapyStageName">/ {{ ruleForm1.secondTherapyStageName }}</span>
            </p>
          </el-form-item>
          <el-form-item label="关注病种:">
            <p>{{ followingDiseaseName }}</p>
          </el-form-item>
          <el-form-item label="当前状态:">
            <p> {{  ruleForm1.patientStatus == 1 ? "住院" : ruleForm1.patientStatus == 2 ? "出院"  : "" }} </p>
          </el-form-item>
          <el-form-item label="主诉:">
            <p>{{ ruleForm1.chiefComplaint }}</p>
          </el-form-item>

          <el-form-item label="现病史:">
            <p>{{ ruleForm1.historyPresentIllness }}</p>
          </el-form-item>

          <el-form-item label="过敏史:">
            <p>{{ ruleForm1.allergicDrugs }}</p>
          </el-form-item>

          <el-form-item label="既往史:">
            <p>{{ ruleForm1.pastMedical }}</p>
          </el-form-item>

          <el-form-item label="个人史:">
            <p>{{ ruleForm1.personalHistory }}</p>
          </el-form-item>

          <el-form-item label="婚育史、月经史:">
            <p>{{ ruleForm1.obstericalHistory }}</p>
          </el-form-item>

          <el-form-item label="家族史:">
            <p>{{ ruleForm1.geneticHistory }}</p>
          </el-form-item>

          <el-form-item label="入院时间:">
            <linkHistory name='入院时间' @getUpTime='getUpTime' :date='ruleForm1.hospitalStaysTime'
              :dateList='ruleForm1.hospitalStaysTimeHistory' />
          </el-form-item>
          <el-form-item label="出院时间:">
            <linkHistory name='出院时间'  @getUpTime='getUpTime' :date='ruleForm1.hospitalDischargeTime'
              :dateList='ruleForm1.hospitalDischargeTimeHistory' />
          </el-form-item>
          <el-form-item label="手术时间:">
            <linkHistory name='手术时间'  @getUpTime='getUpTime' :date='ruleForm1.operationTime' :dateList='ruleForm1.operationTimeHistory' />
          </el-form-item>
          <el-form-item label="其他治疗时间:">
            <linkHistory name='其他治疗时间'  @getUpTime='getUpTime' :date='ruleForm1.otherTreatmentTime'
              :dateList='ruleForm1.otherTreatmentTimeHistory' />
          </el-form-item>
          <el-form-item label="随访时间:">
            <linkHistory name='随访时间'  @getUpTime='getUpTime' :date='ruleForm1.followUpTime' :dateList='ruleForm1.followUpTimeHistory' />
          </el-form-item>
          <el-form-item label="备注:">
            <p>{{ ruleForm1.remark }}</p>
          </el-form-item>
          <div class="ruleForm-title" @click="slideClick1">
            <div class="ruleForm-title-left">
              <span class="span-title"></span><span class="span-text">癌类病种信息</span>
            </div> 
          </div>
          <div v-if="flag1">
            <el-form-item label="病理类型:">
              <p>{{ ruleForm1.pathologicCategory }}</p>
            </el-form-item>

            <el-form-item label="临床分期:">
              <p>{{ ruleForm1.clinicalStage }}</p>
            </el-form-item>
            <el-form-item label="放疗时间:">
              <linkHistory name='放疗时间' @getUpTime='getUpTime' :date='ruleForm1.radiotherapyTime'
                :dateList='ruleForm1.radiotherapyTimeHistory' />
            </el-form-item>
            <el-form-item label="化疗时间:">
              <linkHistory name='化疗时间'  @getUpTime='getUpTime' :date='ruleForm1.chemotherapyTime'
                :dateList='ruleForm1.chemotherapyTimeHistory' />
            </el-form-item>
            <el-form-item label="新辅助放疗时间:">
              <linkHistory name='新辅助放疗时间' @getUpTime='getUpTime' :date='ruleForm1.newAssistRadiotherapyTime'
                :dateList='ruleForm1.newAssistRadiotherapyTimeHistory' />
            </el-form-item>
            <el-form-item label="新辅助化疗时间:">
              <linkHistory name='新辅助化疗时间' @getUpTime='getUpTime' :date='ruleForm1.newAssistChemotherapyTime'
                :dateList='ruleForm1.newAssistChemotherapyTimeHistory' />
            </el-form-item>
            <el-form-item label="PICC维护:">
              <linkHistory name='PICC维护'  @getUpTime='getUpTime' :date='ruleForm1.piccTime' :dateList='ruleForm1.piccTimeHistory' />
            </el-form-item>
            <el-form-item label="新辅助靶向治疗时间:">
              <linkHistory name='新辅助靶向治疗时间'  @getUpTime='getUpTime' :date='ruleForm1.newAssistTargetedTherapyTime'
                :dateList='ruleForm1.newAssistTargetedTherapyTimeHistory' />
            </el-form-item>
            <el-form-item label="靶向治疗时间:">
              <linkHistory name='靶向治疗时间'  @getUpTime='getUpTime' :date='ruleForm1.targetedTherapyTime'
                :dateList='ruleForm1.targetedTherapyTimeHistory' />
            </el-form-item>
            <el-form-item label="内分泌治疗时间:">
              <linkHistory name='内分泌治疗时间'  @getUpTime='getUpTime' :date='ruleForm1.endocrineTherapyTime'
                :dateList='ruleForm1.endocrineTherapyTimeHistory' />
            </el-form-item>
            <el-form-item label="免疫抑制治疗时间:">
              <linkHistory name='免疫抑制治疗时间'  @getUpTime='getUpTime' :date='ruleForm1.immunosuppressiveTherapyTime'
                :dateList='ruleForm1.immunosuppressiveTherapyTimeHistory' />
            </el-form-item>
            <el-form-item label="姑息治疗时间:">
              <linkHistory name='姑息治疗时间'  @getUpTime='getUpTime' :date='ruleForm1.palliativeTherapyTime'
                :dateList='ruleForm1.palliativeTherapyTimeHistory' />

            </el-form-item>
            <el-form-item label="诱导治疗时间:">
              <linkHistory name='诱导治疗时间'  @getUpTime='getUpTime' :date='ruleForm1.inductionTherapyTime'
                :dateList='ruleForm1.inductionTherapyTimeHistory' />
            </el-form-item>
            <el-form-item label="碘131治疗时间:">
              <linkHistory name='碘131治疗时间'   @getUpTime='getUpTime' :date='ruleForm1.iodine131TherapyTime'
                :dateList='ruleForm1.iodine131TherapyTimeHistory' />
            </el-form-item>
            <el-form-item label="血液透析时间:">
              <linkHistory name='血液透析时间'  @getUpTime='getUpTime' :date='ruleForm1.hemodialysisTime'
                :dateList='ruleForm1.hemodialysisTimeHistory' />
            </el-form-item>
            <el-form-item label="腹膜透析时间:">
              <linkHistory name='腹膜透析时间' @getUpTime='getUpTime' :date='ruleForm1.peritonealDialysisTime'
                :dateList='ruleForm1.peritonealDialysisTimeHistory' />
            </el-form-item>
          </div>
          <div class="ruleForm-title" @click="slideClick2">
            <div class="ruleForm-title-left">
              <span class="span-title"></span><span class="span-text">辅助生殖类信息</span>
            </div> 
          </div>
          <div v-if="flag2">
            <el-form-item label="是否辅助生殖:">
              <p>
                {{
                  ruleForm1.isAssistedReproduction === 1
                    ? "是"
                    : ruleForm1.isAssistedReproduction === 2
                    ? "否"
                    : ""
                }}
              </p>
            </el-form-item>

            <!-- 是否辅助生殖 -->
            <div v-if="ruleForm1.isAssistedReproduction === 1">
              <el-form-item v-if="ruleForm1.firstTherapyStageName === 'FET（冻胚）'" label="冻胚数量:">
                <p>{{ ruleForm1.assistedReproductionVO.frozenEmbryoCount }}</p>
              </el-form-item>
              <el-form-item label="上次经期开始时间:">
                <linkHistory name='上次经期开始时间' @getUpTime='getUpTime' :date='ruleForm1.assistedReproductionVO.latestMenstrualDate'
                  :dateList='ruleForm1.assistedReproductionVO.latestMenstrualDateHistory' />
              </el-form-item>
              <el-form-item v-if="ruleForm1.firstTherapyStageName === 'FET（冻胚）'" label="冻胚周期:">
                <p> {{  ruleForm1.assistedReproductionVO.frozenEmbryoCycleType == 1 ? "自然周期" : ruleForm1.assistedReproductionVO.frozenEmbryoCycleType == 2 ? "人工周期"  : "" }} </p>
              </el-form-item>
              <el-form-item label="本次经期开始时间:">
                <linkHistory name='本次经期开始时间' @getUpTime='getUpTime' :date='ruleForm1.assistedReproductionVO.nextMenstrualDate'
                  :dateList='ruleForm1.assistedReproductionVO.nextMenstrualDateHistory' />
              </el-form-item>
              <el-form-item label="夜针时间:">
                <linkHistory name='夜针时间' @getUpTime='getUpTime' :date='ruleForm1.assistedReproductionVO.nightNeedleDate'
                  :dateList='ruleForm1.assistedReproductionVO.nightNeedleDateHistory' />
              </el-form-item>
              <el-form-item label="看胚胎结果时间:">
                <linkHistory name='看胚胎结果时间' @getUpTime='getUpTime' :date='ruleForm1.assistedReproductionVO.embryoResultDate'
                  :dateList='ruleForm1.assistedReproductionVO.embryoResultDateHistory' />
              </el-form-item>
              <el-form-item label="宫腔镜时间:">
                <linkHistory name='宫腔镜时间' @getUpTime='getUpTime' :date='ruleForm1.assistedReproductionVO.hysteroscopyDate'
                  :dateList='ruleForm1.assistedReproductionVO.hysteroscopyDateHistory' />
              </el-form-item>
              <el-form-item label="妊娠确认时间:">
                <linkHistory name='妊娠确认时间' @getUpTime='getUpTime' :date='ruleForm1.assistedReproductionVO.confirmPregnancyDate'
                  :dateList='ruleForm1.assistedReproductionVO.confirmPregnancyDateHistory' />
              </el-form-item>
              <el-form-item label="妊娠后首次B超时间:">
                <linkHistory name='妊娠后首次B超时间' @getUpTime='getUpTime' :date='ruleForm1.assistedReproductionVO.firstPregnancyBScanDate'
                  :dateList='ruleForm1.assistedReproductionVO.firstPregnancyBScanDateHistory' />
              </el-form-item>
              <el-form-item label="妊娠后二次B超时间:">
                  <linkHistory name='妊娠后二次B超时间' @getUpTime='getUpTime' :date='ruleForm1.assistedReproductionVO.secondPregnancyBScanDate'
                               :dateList='ruleForm1.assistedReproductionVO.secondPregnancyBScanDateHistory' />
              </el-form-item>
              <el-form-item label="冻胚进周:">
                <linkHistory name='冻胚进周' @getUpTime='getUpTime' :date='ruleForm1.assistedReproductionVO.frozenEmbryoDate'
                  :dateList='ruleForm1.assistedReproductionVO.frozenEmbryoDateHistory' />
              </el-form-item>
              <el-form-item label="促排时间:">
                <linkHistory name='促排时间' @getUpTime='getUpTime' :date='ruleForm1.assistedReproductionVO.promotingOvulationTime'
                  :dateList='ruleForm1.assistedReproductionVO.promotingOvulationTimeHistory' />
              </el-form-item>
              <el-form-item label="取卵时间:">
                <linkHistory name='取卵时间'  @getUpTime='getUpTime' :date='ruleForm1.assistedReproductionVO.eggRetrievalTime'
                  :dateList='ruleForm1.assistedReproductionVO.eggRetrievalTimeHistory' />
              </el-form-item>
              <el-form-item label="移植时间:">
                <linkHistory name='移植时间'  @getUpTime='getUpTime' :date='ruleForm1.assistedReproductionVO.transplantTime'
                  :dateList='ruleForm1.assistedReproductionVO.transplantTimeHistory' />
              </el-form-item>
              <el-form-item label="移植未孕时间:">
                <linkHistory name='移植未孕时间'   @getUpTime='getUpTime' :date='ruleForm1.assistedReproductionVO.transplantationPregnancyTime'
                  :dateList='ruleForm1.assistedReproductionVO.transplantationPregnancyTimeHistory' />
              </el-form-item>
              <el-form-item label="试管日期:">
                <linkHistory name='试管日期'  @getUpTime='getUpTime' :date='ruleForm1.testTubeDate' :dateList='ruleForm1.testTubeDateHistory' />
              </el-form-item>
              <el-form-item label="试管编号:">
                <div class="chain-relevance" style="display:flex;justify-content:flex-start">
                  <p>{{ ruleForm1.testTubeNumber }}</p>
                  <div v-if="ruleForm1.testTubeUrl" class="pic-box-content">
                    <div class="mask-box">
                      <div class="mask-box-center">
                        <span class="big-icon" @click="bigPicClick(`${imgPath}${ruleForm1.testTubeUrl}`)"><i
                            class="el-icon-zoom-in"></i></span>
                      </div>
                    </div>
                    <img width="100%" :src="imgPath + ruleForm1.testTubeUrl" alt="">
                  </div>
                </div>
              </el-form-item>

              <el-form-item label="辅助生殖手术时间:">
                <linkHistory name='辅助生殖手术时间'  @getUpTime='getUpTime' :date='ruleForm1.assistedReproductionVO.assistedOperationTime'
                  :dateList='ruleForm1.assistedReproductionVO.assistedOperationTimeHistory' />
              </el-form-item>
              <el-form-item label="辅助生殖手术名称:">
                <p>{{ ruleForm1.assistedReproductionVO.operationName }}</p>
              </el-form-item>

              <el-form-item label="辅助生殖手术指征:">
                <p>
                  {{ ruleForm1.assistedReproductionVO.operationIndication }}
                </p>
              </el-form-item>

              <el-form-item label="辅助生殖治疗情况:">
                <p>{{ ruleForm1.assistedReproductionVO.treatmentEffect }}</p>
              </el-form-item>
              <el-form-item label="不良嗜好:">
                <p>
                  <span v-for="(item, key) in ruleForm1.assistedReproductionVO
                      .badHabits" :key="key">
                    <span class="bad-habit" v-if="item !== '其他'">{{
                      item
                    }}</span>
                  </span>
                  <span v-if="
                      ruleForm1.assistedReproductionVO.badHabits.indexOf(
                        '其他'
                      ) > -1
                    ">其他：{{
                      ruleForm1.assistedReproductionVO.badHabitsOther
                    }}</span>
                </p>
                <!-- 选择其他时展示一个文本域用于填写其他不良嗜好？？？？ -->
              </el-form-item>

              <el-form-item label="异常接触史:">
                <p>
                  <span class="bad-habit" v-for="(item, key) in ruleForm1.assistedReproductionVO
                      .abnormalContactHistory" :key="key">{{ item }}</span>
                </p>
              </el-form-item>
              <div v-if="ruleForm1.assistedReproductionVO && ruleForm1.assistedReproductionVO.abnormalContactHistory.indexOf('工业毒物、粉尘接触')> -1">
                <el-form-item label="接触何种工业毒物:">
                  <p>
                    {{ ruleForm1.assistedReproductionVO.industrialPoisons }}
                  </p>
                </el-form-item>

                <el-form-item label="工业毒物接触剂量:">
                  <p>{{ ruleForm1.assistedReproductionVO.exposureDose }}</p>
                </el-form-item>

                <el-form-item label="工业毒物接触频度:">
                  <p>
                    {{
                      ruleForm1.assistedReproductionVO
                        .poisonsContactFrequency === 1
                        ? "长期"
                        : ruleForm1.assistedReproductionVO
                            .poisonsContactFrequency === 2
                        ? "短期"
                        : ruleForm1.assistedReproductionVO
                            .poisonsContactFrequency === 3
                        ? "偶尔"
                        : ""
                    }}
                  </p>
                </el-form-item>

                <el-form-item label="工业毒物接触方式:">
                  <p>
                    {{
                      ruleForm1.assistedReproductionVO.contactType === 1
                        ? "经过呼吸道"
                        : ruleForm1.assistedReproductionVO.contactType === 2
                        ? "经过消化道"
                        : ruleForm1.assistedReproductionVO.contactType === 3
                        ? "经过皮肤黏膜"
                        : ""
                    }}
                  </p>
                </el-form-item>
              </div>
              <el-form-item label="接触何种放射源:" v-if="
                  ruleForm1.assistedReproductionVO &&
                    ruleForm1.assistedReproductionVO.abnormalContactHistory.indexOf(
                      '放射性物质接触'
                    ) > -1
                ">
                <p>{{ ruleForm1.assistedReproductionVO.radioactiveSource }}</p>
              </el-form-item>

              <el-form-item label="放射源接触频度:" v-if="
                  ruleForm1.assistedReproductionVO &&
                    ruleForm1.assistedReproductionVO.abnormalContactHistory.indexOf(
                      '放射性物质接触'
                    ) > -1
                ">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO
                      .radioactiveSourceFrequency == 1
                      ? "长期"
                      : ruleForm1.assistedReproductionVO
                          .radioactiveSourceFrequency === 2
                      ? "短期"
                      : ruleForm1.assistedReproductionVO
                          .radioactiveSourceFrequency === 3
                      ? "偶尔"
                      : ""
                  }}
                </p>
              </el-form-item>

              <el-form-item label="接触疫水时间:" v-if="
                  ruleForm1.assistedReproductionVO &&
                    ruleForm1.assistedReproductionVO.abnormalContactHistory.indexOf(
                      '接触过疫水'
                    ) > -1
                ">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.infectedWaterContactTime
                  }}
                </p>
              </el-form-item>

              <el-form-item label="接触疫水地区:" v-if="
                  ruleForm1.assistedReproductionVO &&
                    ruleForm1.assistedReproductionVO.abnormalContactHistory.indexOf(
                      '接触过疫水'
                    ) > -1
                ">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.infectedWaterContactAreas
                  }}
                </p>
              </el-form-item>
              <el-form-item label="接触疫区时间:" v-if="
                  ruleForm1.assistedReproductionVO &&
                    ruleForm1.assistedReproductionVO.abnormalContactHistory.indexOf(
                      '前往过疫区'
                    ) > -1
                ">
                <p>
                  {{ ruleForm1.assistedReproductionVO.epidemicAreaContactTime }}
                </p>
              </el-form-item>

              <el-form-item label="接触疫区地区:" v-if="
                  ruleForm1.assistedReproductionVO &&
                    ruleForm1.assistedReproductionVO.abnormalContactHistory.indexOf(
                      '前往过疫区'
                    ) > -1
                ">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.epidemicAreaContactAreas
                  }}
                </p>
              </el-form-item>

              <el-form-item label="婚次:">
                <p>{{ ruleForm1.assistedReproductionVO.marriageNumber }}次</p>
              </el-form-item>

              <el-form-item label="婚龄:">
                <p>{{ ruleForm1.assistedReproductionVO.marriageAge }}年</p>
              </el-form-item>

              <el-form-item label="顺产:">
                <p>{{ ruleForm1.assistedReproductionVO.natureBirth }}次</p>
              </el-form-item>

              <el-form-item label="剖宫产:">
                <p>{{ ruleForm1.assistedReproductionVO.cesarean }}次</p>
              </el-form-item>

              <el-form-item label="人流:">
                <p>{{ ruleForm1.assistedReproductionVO.inducedAbortion }}次</p>
              </el-form-item>

              <el-form-item label="药流:">
                <p>{{ ruleForm1.assistedReproductionVO.medicalAbortion }}次</p>
              </el-form-item>

              <el-form-item label="自然流产:">
                <p>{{ ruleForm1.assistedReproductionVO.naturalAbortion }}次</p>
              </el-form-item>
              <el-form-item label="引产:">
                <p>{{ ruleForm1.assistedReproductionVO.inducedLabor }}次</p>
              </el-form-item>
              <el-form-item label="异位妊娠:">
                <p>{{ ruleForm1.assistedReproductionVO.ectopicPregnancy }}次</p>
              </el-form-item>

              <el-form-item label="胚胎停育:">
                <p>{{ ruleForm1.assistedReproductionVO.embryoDamage }}次</p>
              </el-form-item>

              <el-form-item label="产时并发症:">
                <!-- 空格也算是一个字符，单独只有一个分号不做展示 -->
                <p v-if="
                    ruleForm1.assistedReproductionVO.intrapartumComplications.split(
                      /[；;]/
                    )[0]
                  ">
                  <span class="bad-habit" v-for="(item,
                    key) in ruleForm1.assistedReproductionVO.intrapartumComplications.split(
                      /[；;]/
                    )" :key="key">{{ item }}</span>
                </p>
              </el-form-item>
              <el-form-item label="其他系统疾病:">
                <p>
                  <span class="bad-habit" v-for="(item, key) in ruleForm1.assistedReproductionVO
                      .otherDiseaseName" :key="key">{{ item }}</span>
                </p>
              </el-form-item>

              <el-form-item label="妇科相关疾病:">
                <p>
                  <span class="bad-habit" v-for="(item, key) in ruleForm1.assistedReproductionVO
                      .womenDiseaseName" :key="key">{{ item }}</span>
                </p>
              </el-form-item>

              <el-form-item label="初潮年龄:">
                <p>{{ ruleForm1.assistedReproductionVO.menarcheAge }}岁</p>
              </el-form-item>

              <el-form-item label="是否溢乳:">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.isAlactorrhea === 1
                      ? "是"
                      : ruleForm1.assistedReproductionVO.isAlactorrhea === 2
                      ? "否"
                      : ""
                  }}
                </p>
              </el-form-item>

              <el-form-item label="多毛、痤疮、黑棘皮症:">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.isSkinSign === 1
                      ? "是"
                      : ruleForm1.assistedReproductionVO.isSkinSign === 2
                      ? "否"
                      : ""
                  }}
                </p>
              </el-form-item>

              <el-form-item label="疼痛持续状态:">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.painType == 1
                      ? "间歇性疼痛"
                      : ruleForm1.assistedReproductionVO.painType == 2
                      ? "持续疼痛"
                      : ""
                  }}
                </p>
              </el-form-item>

              <el-form-item label="疼痛发作频率:">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.painFrequency !== 21
                      ? translatePainFrequency(
                          ruleForm1.assistedReproductionVO.painFrequency
                        )
                      : ruleForm1.assistedReproductionVO.painFrequencyOther
                  }}
                </p>
              </el-form-item>

              <el-form-item label="疼痛跟月经是否有关:">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.isMenstrualRelated === 1
                      ? "有关"
                      : ruleForm1.assistedReproductionVO.isMenstrualRelated ===
                        2
                      ? "无关"
                      : ""
                  }}
                </p>
              </el-form-item>

              <el-form-item label="疼痛强度:">
                <p>{{ ruleForm1.assistedReproductionVO.painIntensity }}</p>
              </el-form-item>

              <el-form-item label="不孕年限:">
                <p>{{ ruleForm1.assistedReproductionVO.infertilityYears }}</p>
              </el-form-item>

              <el-form-item label="近3月内体重改变:">
                <p>
                  {{ threeMonthsWeightStatus
                  }}{{ ruleForm1.assistedReproductionVO.threeMonthsWeight }}kg
                </p>
              </el-form-item>
              <el-form-item label="盆腹腔疼痛史:">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.ifPelvicPainHistory === 1
                      ? ruleForm1.assistedReproductionVO.pelvicPainHistory
                      : ruleForm1.assistedReproductionVO.ifPelvicPainHistory ===
                        2
                      ? "否"
                      : ""
                  }}
                </p>
              </el-form-item>

              <el-form-item label="性生活频率:">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.sexualLifeFrequency !== 13
                      ? translateSexualLifeFrequency(
                          ruleForm1.assistedReproductionVO.sexualLifeFrequency
                        )
                      : ruleForm1.assistedReproductionVO
                          .sexualLifeFrequencyOther
                  }}
                </p>
              </el-form-item>

              <el-form-item label="是否有性交障碍:">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.isSexualDisorder === 1
                      ? "是"
                      : ruleForm1.assistedReproductionVO.isSexualDisorder === 2
                      ? "否"
                      : ""
                  }}
                </p>
              </el-form-item>

              <el-form-item label="避孕手段:">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.contraceptionType !== 9
                      ? translateContraceptionType(
                          ruleForm1.assistedReproductionVO.contraceptionType
                        )
                      : ruleForm1.assistedReproductionVO.contraceptionTypeOther
                  }}
                </p>
              </el-form-item>

              <el-form-item label="性交痛:">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.sexualIntercoursePain === 1
                      ? "是"
                      : ruleForm1.assistedReproductionVO
                          .sexualIntercoursePain === 2
                      ? "否"
                      : ""
                  }}
                </p>
              </el-form-item>

              <el-form-item label="闭经情况:">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.isAmenorrhea === 1
                      ? "已闭经"
                      : ruleForm1.assistedReproductionVO.isAmenorrhea === 2
                      ? "未闭经"
                      : ""
                  }}
                </p>
              </el-form-item>

              <el-form-item label="绝经时间:" v-if="ruleForm1.assistedReproductionVO.isAmenorrhea === 1">
                <linkHistory name='绝经时间'   @getUpTime='getUpTime' :date='ruleForm1.assistedReproductionVO.lastMenstruation'
                  :dateList='ruleForm1.assistedReproductionVO.lastMenstruationHistory' />
              </el-form-item>
              <el-form-item label="遗传性疾病:">
                <p>
                  <span class="bad-habit" v-for="(item, key) in ruleForm1.assistedReproductionVO
                      .geneticDiseaseName" :key="key">{{ item }}</span>
                </p>
              </el-form-item>

              <el-form-item label="近亲结婚:">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.relativeMarriage === 1
                      ? "是"
                      : ruleForm1.assistedReproductionVO.relativeMarriage === 2
                      ? "否"
                      : ""
                  }}
                </p>
              </el-form-item>

              <el-form-item label="是否有过出生缺陷/智力障碍儿童:" class="birthDefectedChildren">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.birthDefectedChildren == 1
                      ? "是"
                      : ruleForm1.assistedReproductionVO
                          .birthDefectedChildren == 2
                      ? "否"
                      : ""
                  }}
                </p>
              </el-form-item>

              <el-form-item label="本人不孕不育史:">
                <p>
                  {{
                    ruleForm1.assistedReproductionVO.infertilityHistory == 1
                      ? "是"
                      : ruleForm1.assistedReproductionVO.infertilityHistory == 2
                      ? "否"
                      : ""
                  }}
                </p>
              </el-form-item>
            </div>
            <!-- 异常接触史为工业毒物时展示接触何种工业毒物 -->
            <!-- 异常接触史为放射性物质接触时展示接触何种放射源 -->
            <!-- 异常接触史为接触过疫水时展示接触疫水时间 -->
            <!-- 异常接触史为接触过疫区时展示接触疫区时间 -->
          </div>
        </el-form>
        <!-- 编辑状态 -->
        <el-form :model="ruleForm1" label-width="140px" size="mini" ref="ruleForm1" label-position="left" v-else
          class="edit">
          <el-form-item label="当前病种:">
            <el-select v-model="ruleForm1.diseaseObj" value-key="diseaseId" @change="diseaseNameChange" filterable
              remote reserve-keyword :disabled="(ruleForm1.diseaseName && ruleForm1.diseaseName != '其他') ? true : false"
              v-elSelectloadMore="loadmore" :remote-method="val => {remoteDieaseItemMethod(val)}">
              <el-option v-for="item in diseaseList" :key="item.diseaseId" :label="item.diseaseName" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="治疗阶段:">
            <el-cascader ref="therCascader" class="therCascader" :options="therapyStageList" :props="therProps"
              v-model="therapyStageIdList" @change="changeTther"></el-cascader>
          </el-form-item>
          <el-form-item label="关注病种:">
            <p>{{ followingDiseaseName }}</p>
          </el-form-item>
          <el-form-item label="当前状态:">
            <el-select v-model="ruleForm1.patientStatus">
              <el-option :label="item.label" :value="item.value" v-for="(item, index) in patientStatusList"
                :key="index">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主诉:" prop="chiefComplaint">
            <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" resize="none" placeholder="请输入内容"
              v-model="ruleForm1.chiefComplaint">
            </el-input>
          </el-form-item>
          <el-form-item label="现病史:" prop="historyPresentIllness">
            <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" resize="none" placeholder="请输入内容"
              v-model="ruleForm1.historyPresentIllness">
            </el-input>
          </el-form-item>
          <el-form-item label="过敏史:" prop="allergicDrugs">
            <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" resize="none"
              placeholder="请输入过敏史" v-model="ruleForm1.allergicDrugs">
            </el-input>
          </el-form-item>

          <el-form-item label="既往史:">
            <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" resize="none" placeholder="请输入内容"
              v-model="ruleForm1.pastMedical">
            </el-input>
          </el-form-item>

          <el-form-item label="个人史:">
            <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" resize="none" placeholder="请输入内容"
              v-model="ruleForm1.personalHistory">
            </el-input>
          </el-form-item>

          <el-form-item label="婚育史、月经史:">
            <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" resize="none" placeholder="请输入内容"
              v-model="ruleForm1.obstericalHistory">
            </el-input>
          </el-form-item>

          <el-form-item label="家族史:">
            <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" resize="none" placeholder="请输入内容"
              v-model="ruleForm1.geneticHistory">
            </el-input>
          </el-form-item>
          <el-form-item label="入院时间:">
            <el-date-picker v-model="ruleForm1.hospitalStaysTime" :clearable="false" value-format="yyyy-MM-dd"
              type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="出院时间:">
            <el-date-picker v-model="ruleForm1.hospitalDischargeTime" :clearable="false" value-format="yyyy-MM-dd"
              type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="手术时间:">
            <el-date-picker v-model="ruleForm1.operationTime" :clearable="false" value-format="yyyy-MM-dd" type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="其他治疗时间:">
            <el-date-picker v-model="ruleForm1.otherTreatmentTime" :clearable="false" value-format="yyyy-MM-dd"
              type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="随访时间:">
            <el-date-picker v-model="ruleForm1.followUpTime" :clearable="false" value-format="yyyy-MM-dd" type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" resize="none" placeholder="请输入内容"
              v-model="ruleForm1.remark">
            </el-input>
          </el-form-item>
          <div class="ruleForm-title">
            <div class="ruleForm-title-left">
              <span class="span-title"></span><span class="span-text">癌类病种信息</span>
            </div>
          </div>

          <el-form-item label="病理类型:">
            <el-input type="textarea" clearable :autosize="{ minRows: 2, maxRows: 3 }" resize="none" placeholder="请输入内容"
              v-model="ruleForm1.pathologicCategory" :maxlength="50">
            </el-input>
          </el-form-item>

          <el-form-item label="临床分期:">
            <el-input type="textarea" clearable :autosize="{ minRows: 2, maxRows: 3 }" resize="none" placeholder="请输入内容"
              v-model="ruleForm1.clinicalStage" :maxlength="10">
            </el-input>
          </el-form-item>
          <el-form-item label="放疗时间:">
            <el-date-picker v-model="ruleForm1.radiotherapyTime" :clearable="false" value-format="yyyy-MM-dd"
              type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="化疗时间:">
            <el-date-picker v-model="ruleForm1.chemotherapyTime" :clearable="false" value-format="yyyy-MM-dd"
              type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="新辅助放疗时间:">
            <el-date-picker v-model="ruleForm1.newAssistRadiotherapyTime" :clearable="false" value-format="yyyy-MM-dd"
              type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="新辅助化疗时间:">
            <el-date-picker v-model="ruleForm1.newAssistChemotherapyTime" :clearable="false" value-format="yyyy-MM-dd"
              type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="PICC维护:">
            <el-date-picker v-model="ruleForm1.piccTime" :clearable="false" value-format="yyyy-MM-dd" type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="新辅助靶向治疗时间:">
            <el-date-picker v-model="ruleForm1.newAssistTargetedTherapyTime" :clearable="false"
              value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="靶向治疗时间:">
            <el-date-picker v-model="ruleForm1.targetedTherapyTime" :clearable="false" value-format="yyyy-MM-dd"
              type="date" placeholder="请选择靶向治疗时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="内分泌治疗时间:">
            <el-date-picker v-model="ruleForm1.endocrineTherapyTime" :clearable="false" value-format="yyyy-MM-dd"
              type="date" placeholder="请选择内分泌治疗时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="免疫抑制治疗时间:">
            <el-date-picker v-model="ruleForm1.immunosuppressiveTherapyTime" :clearable="false"
              value-format="yyyy-MM-dd" type="date" placeholder="请选择免疫抑制治疗时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="姑息治疗时间:">
            <el-date-picker v-model="ruleForm1.palliativeTherapyTime" :clearable="false" value-format="yyyy-MM-dd"
              type="date" placeholder="请选择姑息治疗时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="诱导治疗时间:">
            <el-date-picker v-model="ruleForm1.inductionTherapyTime" :clearable="false" value-format="yyyy-MM-dd"
              type="date" placeholder="请选择诱导治疗时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="碘131治疗时间:">
            <el-date-picker v-model="ruleForm1.iodine131TherapyTime" :clearable="false" value-format="yyyy-MM-dd"
              type="date" placeholder="请选择碘131治疗时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="血液透析时间:">
            <el-date-picker v-model="ruleForm1.hemodialysisTime" :clearable="false" value-format="yyyy-MM-dd"
              type="date" placeholder="请选择血液透析时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="腹膜透析时间:">
            <el-date-picker v-model="ruleForm1.peritonealDialysisTime" :clearable="false" value-format="yyyy-MM-dd"
              type="date" placeholder="请选择腹膜透析时间">
            </el-date-picker>
          </el-form-item>

          <div class="ruleForm-title">
            <div class="ruleForm-title-left">
              <span class="span-title"></span><span class="span-text">辅助生殖类信息</span>
            </div>
          </div>
          <el-form-item label="是否辅助生殖:">
            <el-radio-group v-model="ruleForm1.isAssistedReproduction">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 辅助生殖字段 -->
          <div v-if="ruleForm1.isAssistedReproduction === 1" :key="ruleForm1.isAssistedReproduction">
            <el-form-item v-if="ruleForm1.firstTherapyStageName === 'FET（冻胚）'" label="冻胚数量:" prop="assistedReproductionVO.frozenEmbryoCount">
              <div>
                <el-input placeholder="请输入冻胚数量，必须为整数" v-model="ruleForm1.assistedReproductionVO.frozenEmbryoCount">
                </el-input>
              </div>
            </el-form-item>
            <el-form-item label="上次经期开始时间:">
              <el-date-picker v-model="
                  ruleForm1.assistedReproductionVO.latestMenstrualDate
                " :clearable="false" value-format="yyyy-MM-dd" type="date" placeholder="选择上次经期开始时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item v-if="ruleForm1.firstTherapyStageName === 'FET（冻胚）'" label="冻胚周期:">
              <el-select v-model="ruleForm1.assistedReproductionVO.frozenEmbryoCycleType">
                <el-option :label="item.label" :value="item.value" v-for="(item, index) in frozenEmbryoCycleTypeList"
                  :key="index">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="本次经期开始时间:">
              <el-date-picker v-model="
                  ruleForm1.assistedReproductionVO.nextMenstrualDate
                " :clearable="false" value-format="yyyy-MM-dd" type="date" placeholder="选择本次经期开始时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="夜针时间:">
              <el-date-picker v-model="
                  ruleForm1.assistedReproductionVO.nightNeedleDate
                " :clearable="false" value-format="yyyy-MM-dd" type="date" placeholder="选择夜针时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="看胚胎结果时间:">
              <el-date-picker v-model="
                  ruleForm1.assistedReproductionVO.embryoResultDate
                " :clearable="false" value-format="yyyy-MM-dd" type="date" placeholder="选择看胚胎结果时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="宫腔镜时间:">
              <el-date-picker v-model="
                  ruleForm1.assistedReproductionVO.hysteroscopyDate
                " :clearable="false" value-format="yyyy-MM-dd" type="date" placeholder="选择宫腔镜时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="妊娠确认时间:">
              <el-date-picker v-model="
                  ruleForm1.assistedReproductionVO.confirmPregnancyDate
                " :clearable="false" value-format="yyyy-MM-dd" type="date" placeholder="选择妊娠确认时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="妊娠后首次B超时间:">
              <el-date-picker v-model="
                  ruleForm1.assistedReproductionVO.firstPregnancyBScanDate
                " :clearable="false" value-format="yyyy-MM-dd" type="date" placeholder="选择妊娠后首次B超时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="妊娠后二次B超时间:">
                <el-date-picker v-model="
                ruleForm1.assistedReproductionVO.secondPregnancyBScanDate
              " :clearable="false" value-format="yyyy-MM-dd" type="date" placeholder="选择妊娠后二次B超时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="冻胚进周:">
              <el-date-picker v-model="
                  ruleForm1.assistedReproductionVO.frozenEmbryoDate
                " :clearable="false" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="促排时间:">
              <el-date-picker v-model="
                  ruleForm1.assistedReproductionVO.promotingOvulationTime
                " :clearable="false" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="取卵时间:">
              <el-date-picker v-model="ruleForm1.assistedReproductionVO.eggRetrievalTime" :clearable="false"
                value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="移植时间:">
              <el-date-picker v-model="ruleForm1.assistedReproductionVO.transplantTime" :clearable="false"
                value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="移植未孕时间:">
              <el-date-picker v-model="ruleForm1.assistedReproductionVO.transplantationPregnancyTime" :clearable="false"
                value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="试管日期:">
              <el-date-picker v-model="ruleForm1.testTubeDate" :clearable="false" :picker-options="pickerOptions0"
                value-format="yyyy-MM-dd" type="date" placeholder="请选择试管日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="试管编号:">
              <el-input type="text" v-model.trim="ruleForm1.testTubeNumber" maxlength="8" placeholder="请输入试管编号">
              </el-input>
            </el-form-item>

            <el-form-item label="辅助生殖手术时间:">
              <el-date-picker v-model="ruleForm1.assistedReproductionVO.assistedOperationTime" :clearable="false"
                value-format="yyyy-MM-dd" type="date" placeholder="请选择辅助生殖手术时间">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="辅助生殖手术名称:">
              <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" :maxlength="200" resize="none"
                placeholder="请输入辅助生殖手术名称(最多输入200字)" v-model="ruleForm1.assistedReproductionVO.operationName">
              </el-input>
            </el-form-item>

            <el-form-item label="辅助生殖手术指征:">
              <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" :maxlength="200" resize="none"
                placeholder="请输入辅助生殖手术指征(最多输入200字)" v-model="ruleForm1.assistedReproductionVO.operationIndication">
              </el-input>
            </el-form-item>

            <el-form-item label="辅助生殖治疗情况:">
              <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" :maxlength="200" resize="none"
                placeholder="请输入辅助生殖治疗情况(最多输入200字)" v-model="ruleForm1.assistedReproductionVO.treatmentEffect">
              </el-input>
            </el-form-item>
            <el-form-item label="不良嗜好:">
              <el-select v-model="ruleForm1.assistedReproductionVO.badHabits" placeholder="请选择不良嗜好" multiple
                @change="badHabitsChange" @remove-tag="
                  value =>
                    value === '其他'
                      ? (ruleForm1.assistedReproductionVO.badHabitsOther = '')
                      : ''
                ">
                <el-option :label="item.label" :key="item.value"
                  :disabled=" ruleForm1.assistedReproductionVO && ruleForm1.assistedReproductionVO.badHabits.indexOf('无') > -1"
                  :value="item.label" v-for="item in badHabitsList">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="其他不良嗜好:" v-if="
                ruleForm1.assistedReproductionVO &&
                  ruleForm1.assistedReproductionVO.badHabits.indexOf('其他') >
                    -1
              ">
              <el-input clearable type="textarea" :autosize="{ minRows: 1, maxRows: 2 }" :maxlength="100" resize="none"
                placeholder="请输入其他不良嗜好(最多输入100字)" v-model="ruleForm1.assistedReproductionVO.badHabitsOther">
              </el-input>
            </el-form-item>

            <el-form-item label="异常接触史:">
              <el-select v-model="
                  ruleForm1.assistedReproductionVO.abnormalContactHistory
                " placeholder="请选择异常接触史" @change="abnormalContactHistoryChange" multiple
                @remove-tag="abnormalContactHistoryRemove">
                <el-option :label="item.label" :disabled="
                    ruleForm1.assistedReproductionVO &&
                      ruleForm1.assistedReproductionVO.abnormalContactHistory.indexOf(
                        '无'
                      ) > -1
                  " :value="item.label" v-for="item in abnormalContactHistoryList" :key="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 异常接触史为工业毒物时展示接触何种工业毒物 -->
            <div v-if="
                ruleForm1.assistedReproductionVO &&
                  ruleForm1.assistedReproductionVO.abnormalContactHistory.indexOf(
                    '工业毒物、粉尘接触'
                  ) > -1
              ">
              <el-form-item label="接触何种工业毒物:">
                <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" :maxlength="100"
                  resize="none" placeholder="请输入接触何种工业毒物(最多输入100字)"
                  v-model="ruleForm1.assistedReproductionVO.industrialPoisons">
                </el-input>
              </el-form-item>

              <el-form-item label="工业毒物接触剂量:">
                <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" :maxlength="100"
                  resize="none" placeholder="请输入工业毒物接触剂量(最多输入100字)"
                  v-model="ruleForm1.assistedReproductionVO.exposureDose">
                </el-input>
              </el-form-item>

              <el-form-item label="工业毒物接触频度:">
                <el-select v-model="
                    ruleForm1.assistedReproductionVO.poisonsContactFrequency
                  " placeholder="请选择工业毒物接触频度">
                  <el-option :label="item.label" :value="item.value"
                    v-for="(item, index) in poisonsContactFrequencyList" :key="index">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="工业毒物接触方式:">
                <el-select v-model="ruleForm1.assistedReproductionVO.contactType" placeholder="请选择工业毒物接触方式">
                  <el-option :label="item.label" :value="item.value" v-for="(item, index) in contactTypeList"
                    :key="index">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <!-- 异常接触史为放射性物质接触时展示接触何种放射源 -->
            <div v-if="
                ruleForm1.assistedReproductionVO &&
                  ruleForm1.assistedReproductionVO.abnormalContactHistory.indexOf(
                    '放射性物质接触'
                  ) > -1
              ">
              <el-form-item label="接触何种放射源:">
                <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" :maxlength="100"
                  resize="none" placeholder="请输入接触何种放射源(最多输入100字)"
                  v-model="ruleForm1.assistedReproductionVO.radioactiveSource">
                </el-input>
              </el-form-item>

              <el-form-item label="放射源接触频度:">
                <el-select v-model="
                    ruleForm1.assistedReproductionVO.radioactiveSourceFrequency
                  " placeholder="请选择放射源接触频">
                  <el-option :label="item.label" :value="item.value"
                    v-for="(item, index) in poisonsContactFrequencyList" :key="index">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <!-- 异常接触史为接触过疫水时展示接触疫水时间 -->
            <div v-if="
                ruleForm1.assistedReproductionVO &&
                  ruleForm1.assistedReproductionVO.abnormalContactHistory.indexOf(
                    '接触过疫水'
                  ) > -1
              ">
              <el-form-item label="接触疫水时间:">
                <el-date-picker v-model="
                    ruleForm1.assistedReproductionVO.infectedWaterContactTime
                  " :clearable="false" value-format="yyyy-MM-dd" type="date" placeholder="选择接触疫水时间"> 
                </el-date-picker>
              </el-form-item>

              <el-form-item label="接触疫水地区:">
                <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" :maxlength="100"
                  resize="none" placeholder="请输入接触疫水地区(最多输入100字)" v-model="
                    ruleForm1.assistedReproductionVO.infectedWaterContactAreas
                  ">
                </el-input>
              </el-form-item>
            </div>
            <el-form-item label="婚次:" prop="assistedReproductionVO.marriageNumber">
              <div>
                <el-input placeholder="请输入结婚次数，必须为整数" v-model="ruleForm1.assistedReproductionVO.marriageNumber">
                  <template slot="append">次</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="婚龄:" prop="assistedReproductionVO.marriageAge">
              <div>
                <el-input placeholder="请输入婚龄，精确到小数点后一位" v-model="ruleForm1.assistedReproductionVO.marriageAge">
                  <template slot="append">年</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="顺产:" prop="assistedReproductionVO.natureBirth">
              <div>
                <el-input placeholder="请输入顺产次数，必须为整数" v-model="ruleForm1.assistedReproductionVO.natureBirth">
                  <template slot="append">次</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="剖宫产:" prop="assistedReproductionVO.cesarean">
              <div>
                <el-input placeholder="请输入剖宫产次数，必须为整数" v-model="ruleForm1.assistedReproductionVO.cesarean">
                  <template slot="append">次</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="人流:" prop="assistedReproductionVO.inducedAbortion">
              <div>
                <el-input placeholder="请输入人流次数，必须为整数" v-model="ruleForm1.assistedReproductionVO.inducedAbortion">
                  <template slot="append">次</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="药流:" prop="assistedReproductionVO.medicalAbortion">
              <div>
                <el-input placeholder="请输入药流次数，必须为整数" v-model="ruleForm1.assistedReproductionVO.medicalAbortion">
                  <template slot="append">次</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="自然流产:" prop="assistedReproductionVO.naturalAbortion">
              <div>
                <el-input placeholder="请输入自然流产次数，必须为整数" v-model="ruleForm1.assistedReproductionVO.naturalAbortion">
                  <template slot="append">次</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="引产:" prop="assistedReproductionVO.inducedLabor">
              <div>
                <el-input placeholder="请输入引产次数，必须为整数" v-model="ruleForm1.assistedReproductionVO.inducedLabor">
                  <template slot="append">次</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="异位妊娠:" prop="assistedReproductionVO.ectopicPregnancy">
              <div>
                <el-input placeholder="请输入异位妊娠次数，必须为整数" v-model="ruleForm1.assistedReproductionVO.ectopicPregnancy">
                  <template slot="append">次</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="胚胎停育:" prop="assistedReproductionVO.embryoDamage">
              <div>
                <el-input placeholder="请输入胚胎停育次数，必须为整数" v-model="ruleForm1.assistedReproductionVO.embryoDamage">
                  <template slot="append">次</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="产时并发症:">
              <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" :maxlength="200" resize="none"
                placeholder="请输入产时并发症，不同并发症用“；”隔开(最多输入200字)" v-model="
                  ruleForm1.assistedReproductionVO.intrapartumComplications
                ">
              </el-input>
            </el-form-item>

            <el-form-item label="其他系统疾病:">
              <el-select v-model="ruleForm1.assistedReproductionVO.otherDiseaseName" multiple filterable remote
                reserve-keyword placeholder="请搜索选择其他系统疾病" :remote-method="
                  query => remoteMethod(query, 'otherDiseaseList')
                " :loading="loading" @change="
                  value => diseaseNameMaxChange(value, 'otherDiseaseName')
                ">
                <el-option v-for="item in otherDiseaseList" :key="item.value" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="妇科相关疾病:">
              <el-select v-model="ruleForm1.assistedReproductionVO.womenDiseaseName" multiple filterable remote
                reserve-keyword placeholder="请搜索选择妇科相关疾病" :remote-method="
                  query => remoteMethod(query, 'womenDiseaseList')
                " :loading="loading" @change="
                  value => diseaseNameMaxChange(value, 'womenDiseaseName')
                ">
                <el-option v-for="item in womenDiseaseList" :key="item.value" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="初潮年龄:" prop="assistedReproductionVO.menarcheAge">
              <div>
                <el-input placeholder="请输入初潮年龄，必须为整数" v-model="ruleForm1.assistedReproductionVO.menarcheAge">
                  <template slot="append">岁</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="是否溢乳:">
              <el-radio-group v-model="ruleForm1.assistedReproductionVO.isAlactorrhea">
                <el-radio :label="1" @click.native.prevent="radioCheckChange('isAlactorrhea', 1)">是
                </el-radio>
                <el-radio :label="2" @click.native.prevent="radioCheckChange('isAlactorrhea', 2)">否
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="多毛、痤疮、黑棘皮症:">
              <el-radio-group v-model="ruleForm1.assistedReproductionVO.isSkinSign">
                <el-radio :label="1" @click.native.prevent="radioCheckChange('isSkinSign', 1)">是
                </el-radio>
                <el-radio :label="2" @click.native.prevent="radioCheckChange('isSkinSign', 2)">否
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="疼痛持续状态:">
              <el-select v-model="ruleForm1.assistedReproductionVO.painType" placeholder="请选择疼痛持续状态">
                <el-option label="间歇性疼痛" :value="1"></el-option>
                <el-option label="持续疼痛" :value="2"></el-option>
                <!--<el-option :label="item.label" :value="item.value" v-for="(item,index) in patientStatusList"
                  :key="index">
                </el-option>-->
              </el-select>
            </el-form-item>

            <el-form-item label="疼痛发作频率:">
              <el-select v-model="ruleForm1.assistedReproductionVO.painFrequency" placeholder="请选择疼痛发作频率" @change="
                  value =>
                    value !== 21
                      ? (ruleForm1.assistedReproductionVO.painFrequencyOther =
                          '')
                      : ''
                ">
                <el-option :label="item.label" :value="item.value" v-for="(item, index) in painFrequencyList"
                  :key="index">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="其他疼痛发作频率:" v-if="ruleForm1.assistedReproductionVO.painFrequency === 21">
              <el-input clearable type="textarea" :autosize="{ minRows: 1, maxRows: 2 }" :maxlength="100" resize="none"
                placeholder="请输入其他疼痛发作频率" v-model="ruleForm1.assistedReproductionVO.painFrequencyOther">
              </el-input>
            </el-form-item>

            <el-form-item label="疼痛跟月经是否有关:">
              <el-radio-group v-model="ruleForm1.assistedReproductionVO.isMenstrualRelated">
                <el-radio :label="1" @click.native.prevent="
                    radioCheckChange('isMenstrualRelated', 1)
                  ">是
                </el-radio>
                <el-radio :label="2" @click.native.prevent="
                    radioCheckChange('isMenstrualRelated', 2)
                  ">否
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="疼痛强度:">
              <el-select v-model="ruleForm1.assistedReproductionVO.painIntensity" placeholder="请选择疼痛强度">
                <el-option :label="item.label" :value="item.value" v-for="(item, index) in painIntensityList"
                  :key="index">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="不孕年限:" prop="assistedReproductionVO.infertilityYears">
              <div>
                <el-input placeholder="请输入不孕年限，精确到小数点后一位" v-model="ruleForm1.assistedReproductionVO.infertilityYears">
                  <template slot="append">年</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="近三月内体重改变:" prop="assistedReproductionVO.threeMonthsWeight">
              <div style="display: flex">
                <el-select v-model="threeMonthsWeightStatus" class="select-box">
                  <el-option label="+" value="+"></el-option>
                  <el-option label="-" value="-"></el-option>
                </el-select>
                <el-input placeholder="请输入近三月内体重变化，必须为整数" v-model="ruleForm1.assistedReproductionVO.threeMonthsWeight">
                  <template slot="append">kg</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="盆腹腔疼痛史:">
              <el-radio-group v-model="ruleForm1.assistedReproductionVO.ifPelvicPainHistory">
                <el-radio :label="1" @click.native.prevent="
                    radioCheckChange('ifPelvicPainHistory', 1)
                  ">是
                </el-radio>
                <el-radio :label="2" @click.native.prevent="
                    radioCheckChange('ifPelvicPainHistory', 2)
                  ">否
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="详情:" v-if="ruleForm1.assistedReproductionVO.ifPelvicPainHistory === 1">
              <el-input clearable type="textarea" :autosize="{ minRows: 1, maxRows: 2 }" :maxlength="200" resize="none"
                placeholder="请输入盆腹腔疼痛史(最多输入200字)" v-model="ruleForm1.assistedReproductionVO.pelvicPainHistory">
              </el-input>
            </el-form-item>

            <el-form-item label="性生活频率:">
              <el-select v-model="ruleForm1.assistedReproductionVO.sexualLifeFrequency" placeholder="请选择性生活频率" clearable
                @change="
                  value =>
                    value !== 13
                      ? (ruleForm1.assistedReproductionVO.sexualLifeFrequencyOther =
                          '')
                      : ''
                ">
                <el-option :label="item.label" :value="item.value" v-for="(item, index) in sexualLifeFrequencyList"
                  :key="index">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="其他性生活频率:" v-if="ruleForm1.assistedReproductionVO.sexualLifeFrequency === 13">
              <el-input clearable type="textarea" :autosize="{ minRows: 1, maxRows: 2 }" :maxlength="100" resize="none"
                placeholder="请输入其他性生活频率(最多输入100字)" v-model="
                  ruleForm1.assistedReproductionVO.sexualLifeFrequencyOther
                ">
              </el-input>
            </el-form-item>

            <el-form-item label="是否有性交障碍:">
              <el-radio-group v-model="ruleForm1.assistedReproductionVO.isSexualDisorder">
                <el-radio :label="1" @click.native.prevent="
                    radioCheckChange('isSexualDisorder', 1)
                  ">是
                </el-radio>
                <el-radio :label="2" @click.native.prevent="
                    radioCheckChange('isSexualDisorder', 2)
                  ">否
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="避孕手段:">
              <el-select v-model="ruleForm1.assistedReproductionVO.contraceptionType" placeholder="请选择避孕手段" clearable
                @change="
                  value =>
                    value !== 9
                      ? (ruleForm1.assistedReproductionVO.contraceptionTypeOther =
                          '')
                      : ''
                ">
                <el-option :label="item.label" :value="item.value" v-for="(item, index) in contraceptionTypeList"
                  :key="index">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="其他避孕手段:" v-if="ruleForm1.assistedReproductionVO.contraceptionType === 9">
              <el-input clearable type="textarea" :autosize="{ minRows: 1, maxRows: 2 }" :maxlength="100" resize="none"
                placeholder="请输入其他避孕手段(最多输入100字)" v-model="
                  ruleForm1.assistedReproductionVO.contraceptionTypeOther
                ">
              </el-input>
            </el-form-item>

            <el-form-item label="性交痛:">
              <el-radio-group v-model="ruleForm1.assistedReproductionVO.sexualIntercoursePain">
                <el-radio :label="1" @click.native.prevent="
                    radioCheckChange('sexualIntercoursePain', 1)
                  ">是
                </el-radio>
                <el-radio :label="2" @click.native.prevent="
                    radioCheckChange('sexualIntercoursePain', 2)
                  ">否
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="闭经情况:">
              <el-radio-group v-model="ruleForm1.assistedReproductionVO.isAmenorrhea" @change="
                  value =>
                    value !== 1
                      ? (ruleForm1.assistedReproductionVO.lastMenstruation = '')
                      : ''
                ">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="绝经时间:" v-if="ruleForm1.assistedReproductionVO.isAmenorrhea === 1">
              <el-date-picker v-model="ruleForm1.assistedReproductionVO.lastMenstruation" :clearable="false"
                value-format="yyyy-MM-dd" type="date" placeholder="选择绝经时间">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="遗传性疾病:">
              <el-select v-model="ruleForm1.assistedReproductionVO.geneticDiseaseName" multiple filterable remote
                reserve-keyword placeholder="请搜索选择遗传性疾病" :remote-method="
                  query => remoteMethod(query, 'geneticDiseaseList')
                " :loading="loading" @change="
                  value => diseaseNameMaxChange(value, 'geneticDiseaseName')
                ">
                <el-option v-for="item in geneticDiseaseList" :key="item.value" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="近亲结婚:">
              <el-radio-group v-model="ruleForm1.assistedReproductionVO.relativeMarriage">
                <el-radio :label="1" @click.native.prevent="
                    radioCheckChange('relativeMarriage', 1)
                  ">是
                </el-radio>
                <el-radio :label="2" @click.native.prevent="
                    radioCheckChange('relativeMarriage', 2)
                  ">否
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="是否有过出生缺陷/智力障碍儿童:" class="birthDefectedChildren">
              <el-radio-group v-model="ruleForm1.assistedReproductionVO.birthDefectedChildren">
                <el-radio :label="1" @click.native.prevent="
                    radioCheckChange('birthDefectedChildren', 1)
                  ">是
                </el-radio>
                <el-radio :label="2" @click.native.prevent="
                    radioCheckChange('birthDefectedChildren', 2)
                  ">否
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="本人不孕不育史:">
              <el-radio-group v-model="ruleForm1.assistedReproductionVO.infertilityHistory">
                <el-radio :label="1" @click.native.prevent="
                    radioCheckChange('infertilityHistory', 1)
                  ">是
                </el-radio>
                <el-radio :label="2" @click.native.prevent="
                    radioCheckChange('infertilityHistory', 2)
                  ">否
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-form>
        <!-- 新增术语 -->
        <el-form size="mini" label-width="142px" label-position="left" label-suffix=":">
          <el-tooltip class="item" effect="dark" :content="item.name" placement="left" v-for="(item, key) in jargonList"
            :key="key" :disabled="item.name && item.name.length <= 8">
            <el-form-item :label="
                item.name && item.name.length > 8
                  ? item.name.slice(0, 8) + '……'
                  : item.name
              ">
              <p v-if="!isEdit">{{ item.value }}</p>
              <el-date-picker v-if="isEdit && item.recordType === 'date'" value-format="yyyy-MM-dd" :clearable="false"
                v-model="item.value" type="date" placeholder="选择日期">
              </el-date-picker>
              <el-input-number v-if="isEdit && item.recordType === 'number'" v-model.trim="item.value"
                controls-position="right" :min="1" placeholder="请输入当前体重">
              </el-input-number>
              <el-input v-if="isEdit && item.recordType === 'string'" v-model.trim="item.value">
              </el-input>
            </el-form-item>
          </el-tooltip>
        </el-form>
      </el-scrollbar>
    </div>
    <div class="btn">
      <el-button type="primary" plain @click="infoEdit2" v-if="!isEdit" size="small">编辑</el-button>
      <el-button type="primary" plain @click="submitHandel" v-else size="small">保存</el-button>
    </div>
    <!-- 查看图片大图 -->
    <previewPic v-if="showLargePic" :showLargePic.sync="showLargePic" :picUrl="testTubeUrl"></previewPic>
  </div>
</template>

<script>
// 校验是重点，以及字段调整！！！！！！！！！！-----结婚次，结婚次数必须为正整数病情要在0-99之间
import {
    getFindIcdDiseaseByCondition,
    getFollowingListByPatient,
    terminologyMultipleInsert,
    UpdatepatientArchiesRight
} from "../../api";

import {findDiseaseTypeByAdmin} from "@/api/Patientmanagement.js";

import {DEEP_CLONE} from "@/utils/constants";
import {getTherapyStageByDiseaseId} from "@/views/treatment/api";

// 正整数，0-99 不得输入00…… 01…… 001……
const validatorInteger = (rule, value, callback) => {
  const reg = /^[1-9]\d?$/g;
  if (reg.test(value)) {
    callback();
  } else {
    callback(new Error("请输入正确的区间范围!"));
  }
};

// 整数，一位小数点，0-99.9 不能输入00.1或者000.……
const validatorFloat = (rule, value, callback) => {
  const reg = /(^0(\.\d)?$)|(^[1-9]\d?(\.[1-9])?$)/g;
  if (reg.test(value)) {
    callback();
  } else {
    callback(new Error("请输入正确的婚次"));
  }
};
export default {
  name: "UserDetails",
  props: {
    userDetailsData: {
      type: Object,
      default: () => {}
    },
    currentActive: {
      type: String,
      default: ""
    },
    jargonList: {
      type: Array,
      default: () => {
        [];
      }
    }
  },
  components: {
    RelateChain: () =>
      import(
        "@/views/treatment/components/CrossReferenceEntry/RelateChain.vue"
      ),
    linkHistory: () => import("./linkHistory.vue"),
    previewPic: () => import("@/components/previewPic.vue")
  },
  data() {
    return {
      showFlag: false,
      time1: false,
      imgPath: process.env.VUE_APP_OSS_URL,
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      therProps: {
        value: "therapyStageId",
        label: "therapyStageName"
      },
      therapyStageIdList: "",
      patientId: "",
      followingDiseaseName: "", // 患者关注病种
      ruleForm1: {
        firstTherapyStageId: "", //治疗阶段一级
        firstTherapyStageName: "",
        secondTherapyStageId: "", //治疗阶段二级
        secondTherapyStageName: "",
        radiotherapyTime: "", //放疗时间
        radiotherapyTimeHistory: [],
        chemotherapyTime: "", //化疗时间
        chemotherapyTimeHistory: [],

        newAssistRadiotherapyTime: "",
        newAssistRadiotherapyTimeHistory: [],
        newAssistChemotherapyTime: "",
        newAssistChemotherapyTimeHistory: [],
        piccTime: "",
        piccTimeHistory: [],
        newAssistTargetedTherapyTime: "",
        newAssistTargetedTherapyTimeHistory: [],
        targetedTherapyTime: "",
        targetedTherapyTimeHistory: [],

        patientId: "",
        diseaseId: "", // 当前病种id
        diseaseName: "", // 当前病种名称
        diseaseObj: {},
        clinicalStage: "", // 临床分期
        pathologicCategory: "", // 病理类型
        therapyStageObj: {}, // 治疗阶段对象存储
        therapyStage: "", // 治疗阶段
        therapyStageId: "", // 治疗阶段id
        patientStatus: "", //	当前状态 1住院 2出院
        hospitalizedNumber: "", //最近一次住院天数:
        hospitalStaysTime: "", //	最近一次入院时间
        hospitalStaysTimeHistory: [],
        hospitalDischargeTime: "", //	最近一次出院时间
        hospitalDischargeTimeHistory: [],
        operationStatus: "", //	在院期间是否进行手术 1 是 2 否
        operationTime: "", //最近一次手术时间
        operationTimeHistory: [],
        otherTreatmentTime: "", //其他治疗时间
        otherTreatmentTimeHistory: [],
        followUpTime: "", //随访时间
        followUpTimeHistory: [],
        outpatientStatus: "", //	近期是否门诊就诊 1 是 2 否
        clinicTime: "", //	门诊就诊时间
        diagnosis: "", //	入院主要诊断
        hospitalizedSecondaryDiagnosis: "", //	入院次要诊断
        diagnosisOther: "", //	入院其他诊断
        dischargeDiagnosis: "", //	出院诊断
        outpatientPrincipalDiagnosis: "", //	门诊主要诊断
        outpatientSecondaryDiagnosis: "", //	门诊次要诊断
        outpatientOtherDiagnosis: "", //	门诊其他诊断
        outpatientClinicDepartment: "", //	门诊就诊科室
        chiefComplaint: "", //	主诉
        historyPresentIllness: "", //	现病史
        allergicDrugs: "", // 过敏史
        pastMedical: "", //	既往史
        personalHistory: "", //	个人史
        operationHistory: "", //手术史
        obstericalHistory: "", //	婚育史/月经史
        geneticHistory: "", //	家族病史
        leaveHospitalRecord: "", //	出院记录
        remark: "", //	个案备注
        id: "", //	id
        endocrineTherapyTime: "",
        endocrineTherapyTimeHistory: [],
        immunosuppressiveTherapyTime: "",
        immunosuppressiveTherapyTimeHistory: [],
        palliativeTherapyTime: "",
        palliativeTherapyTimeHistory: [],
        inductionTherapyTime: "",
        inductionTherapyTimeHistory: [],
        iodine131TherapyTime: "",
        iodine131TherapyTimeHistory: [],
        hemodialysisTime: "",
        hemodialysisTimeHistory: [],
        peritonealDialysisTime: "",
        peritonealDialysisTimeHistory: [],
        // 试管
        testTubeDate: null,
        testTubeDateHistory: [],
        testTubeNumber: "",
        testTubeUrl: "",
        // 辅助生殖新增字段内容
        isAssistedReproduction: 2,
        // 辅助生殖对象
        assistedReproductionVO: {
          frozenEmbryoCount: "", // 冻胚数量
          latestMenstrualDate: "", // 上次经期开始时间
          latestMenstrualDateHistory: "",
          frozenEmbryoCycleType: "", //冻胚周期
          nextMenstrualDate: "", //本次经期开始时间
          nextMenstrualDateHistory: "",
          nightNeedleDate: "", //夜针时间
          nightNeedleDateHistory: "",
          embryoResultDate: "", //看胚胎结果时间
          embryoResultDateHistory: "",
          hysteroscopyDate: "", //宫腔镜时间
          hysteroscopyDateHistory: "",
          confirmPregnancyDate: "", //妊娠确认时间
          confirmPregnancyDateHistory: "",
          firstPregnancyBScanDate: "", //妊娠后首次B超时间
          firstPregnancyBScanDateHistory: "",
          secondPregnancyBScanDate: "", //妊娠后二次B超时间
          secondPregnancyBScanDateHistory: "",
          frozenEmbryoDate: "", //冻胚进周
          frozenEmbryoDateHistory: "",
          promotingOvulationTime: "", //促排时间
          promotingOvulationTimeHistory: [],
          eggRetrievalTime: "", //取卵时间
          eggRetrievalTimeHistory: [],
          transplantTime: "", //移植时间
          transplantTimeHistory: [],
          abnormalContactHistory: [],
          transplantationPregnancyTime: "",
          transplantationPregnancyTimeHistory: [],
          badHabits: [],
          badHabitsOther: "",
          birthDefectedChildren: "",
          cesarean: "",
          contactType: "",
          contraceptionType: "",
          contraceptionTypeOther: "",
          ectopicPregnancy: "",
          embryoDamage: "",
          epidemicAreaContactAreas: "",
          epidemicAreaContactTime: "",
          exposureDose: "",
          otherDiseaseName: "",
          womenDiseaseName: "",
          geneticDiseaseName: "",
          ifPelvicPainHistory: "",
          inducedAbortion: "",
          inducedLabor: "",
          industrialPoisons: "",
          infectedWaterContactAreas: "",
          infectedWaterContactTime: "",
          infertilityHistory: "",
          infertilityYears: "",
          intrapartumComplications: "",
          isAlactorrhea: "",
          isAmenorrhea: "",
          isMenstrualRelated: "",
          isSexualDisorder: "",
          isSkinSign: "",
          lastMenstruation: "",
          lastMenstruationHistory: [],
          marriageAge: "",
          marriageNumber: "",
          medicalAbortion: "",
          menarcheAge: "",
          naturalAbortion: "",
          natureBirth: "",
          operationIndication: "",
          operationName: "",
          assistedOperationTime: "",
          assistedOperationTimeHistory: [],
          painFrequency: "",
          painFrequencyOther: "",
          painIntensity: "",
          painType: "",
          pelvicPainHistory: "",
          poisonsContactFrequency: "",
          radioactiveSource: "",
          radioactiveSourceFrequency: "",
          relativeMarriage: "",
          sexualIntercoursePain: "",
          sexualLifeFrequency: "",
          sexualLifeFrequencyOther: "",
          threeMonthsWeight: "",
          treatmentEffect: ""
        }
      },
      rules: {
        clinicTime: [
          { required: true, message: "请选择门诊就诊时间", trigger: "change" }
        ],
        outpatientStatus: [
          {
            required: true,
            message: "请选择近期是否门诊就诊",
            trigger: "change"
          }
        ],
        outpatientPrincipalDiagnosis: [
          { required: true, message: "请输入门诊主要诊断", trigger: "blur" }
        ],
        outpatientClinicDepartment: [
          { required: true, message: "请输入门诊就诊科室", trigger: "blur" }
        ],
        chiefComplaint: [
          { required: true, message: "请输入主诉", trigger: "blur" }
        ],
        historyPresentIllness: [
          { required: true, message: "请输入现病史", trigger: "blur" }
        ],
        // 辅助生殖字段
        assistedReproductionVO: {
          frozenEmbryoCount: [
            {
                required: false,
                message: "请输入正确的冻胚数量",
                trigger: ["blur", "change"],
                validator: validatorInteger
            }
          ],
          marriageNumber: [
            {
              required: false,
              message: "请输入正确的婚次",
              trigger: ["blur", "change"],
              validator: validatorInteger
            }
          ],
          natureBirth: [
            {
              required: false,
              message: "请输入正确的顺产次数",
              trigger: ["blur", "change"],
              validator: validatorInteger
            }
          ],
          cesarean: [
            {
              required: false,
              message: "请输入正确的抛宫产次数",
              trigger: ["blur", "change"],
              validator: validatorInteger
            }
          ],
          inducedAbortion: [
            {
              required: false,
              message: "请输入正确的人流次数",
              trigger: ["blur", "change"],
              validator: validatorInteger
            }
          ],
          medicalAbortion: [
            {
              required: false,
              message: "请输入正确的药流次数",
              trigger: ["blur", "change"],
              validator: validatorInteger
            }
          ],
          naturalAbortion: [
            {
              required: false,
              message: "请输入正确的自然流产次数",
              trigger: ["blur", "change"],
              validator: validatorInteger
            }
          ],
          inducedLabor: [
            {
              required: false,
              message: "请输入正确的引产次数",
              trigger: ["blur", "change"],
              validator: validatorInteger
            }
          ],
          ectopicPregnancy: [
            {
              required: false,
              message: "请输入正确的异位妊娠次数",
              trigger: ["blur", "change"],
              validator: validatorInteger
            }
          ],
          embryoDamage: [
            {
              required: false,
              message: "请输入正确的胚胎停育次数",
              trigger: ["blur", "change"],
              validator: validatorInteger
            }
          ],
          menarcheAge: [
            {
              required: false,
              message: "请输入正确的初潮年龄",
              trigger: ["blur", "change"],
              validator: validatorInteger
            }
          ],
          marriageAge: [
            {
              required: false,
              message: "请输入正确的婚龄",
              trigger: ["blur", "change"],
              validator: validatorFloat
            }
          ],
          infertilityYears: [
            {
              required: false,
              message: "请输入正确的不孕年限",
              trigger: ["blur", "change"],
              validator: validatorFloat
            }
          ],
          threeMonthsWeight: [
            {
              required: false,
              message: "请输入正确的体重变化",
              trigger: ["blur", "change"],
              validator: validatorFloat
            }
          ]
        }
      },
      isEdit: false, //false 为编辑 true 为保存
      patientStatusList: [
        {
          label: "住院",
          value: 1
        },
        {
          label: "出院",
          value: 2
        }
      ],
      operationStatusList: [
        {
          label: "是",
          value: 1
        },
        {
          label: "否",
          value: 2
        }
      ],
      // 不良嗜好
      badHabitsList: [
        {
          label: "抽烟",
          value: 1
        },
        {
          label: "酗酒",
          value: 2
        },
        {
          label: "暴力",
          value: 3
        },
        {
          label: "沉迷网游",
          value: 4
        },
        {
          label: "赌博",
          value: 5
        },
        {
          label: "吸毒",
          value: 6
        },
        {
          label: "涉黄",
          value: 7
        },
        {
          label: "其他",
          value: 8
        },
        {
          label: "无",
          value: 9
        }
      ],
      // 异常接触史
      abnormalContactHistoryList: [
        {
          label: "工业毒物、粉尘接触",
          value: 1
        },
        {
          label: "放射性物质接触",
          value: 2
        },
        {
          label: "接触过疫水",
          value: 3
        },
        {
          label: "前往过疫区",
          value: 4
        },
        {
          label: "无",
          value: 5
        }
      ],
      // 工业毒物接触方式
      contactTypeList: [
        {
          label: "经过呼吸道",
          value: 1
        },
        {
          label: "经过消化道",
          value: 2
        },
        {
          label: "经过皮肤黏膜",
          value: 3
        }
      ],
      // 避孕手段
      contraceptionTypeList: [
        {
          label: "避孕药避孕-紧急避孕药",
          value: 1
        },
        {
          label: "避孕药避孕-短效避孕药",
          value: 2
        },
        {
          label: "避孕药避孕-长效避孕药",
          value: 3
        },
        {
          label: "安全期避孕",
          value: 4
        },
        {
          label: "节育环避孕",
          value: 5
        },
        {
          label: "结扎避孕",
          value: 6
        },
        {
          label: "避孕套避孕",
          value: 7
        },
        {
          label: "皮下埋置避孕",
          value: 8
        },
        {
          label: "其他",
          value: 9
        }
      ],
      // 疼痛发作频率
      painFrequencyList: [
        {
          label: "每日一次",
          value: 1
        },
        {
          label: "每日两次",
          value: 2
        },
        {
          label: "每日三次",
          value: 3
        },
        {
          label: "每日四次",
          value: 4
        },
        {
          label: "隔日一次",
          value: 5
        },
        {
          label: "隔周一次",
          value: 6
        },
        {
          label: "每周一次",
          value: 7
        },
        {
          label: "每周两次",
          value: 8
        },
        {
          label: "每周三次",
          value: 9
        },
        {
          label: "每两周一次",
          value: 10
        },
        {
          label: "每三周一次",
          value: 11
        },
        {
          label: "每四周一次",
          value: 12
        },
        {
          label: "每半小时一次",
          value: 13
        },
        {
          label: "每小时一次",
          value: 14
        },
        {
          label: "两小时一次",
          value: 15
        },
        {
          label: "三小时一次",
          value: 16
        },
        {
          label: "四小时一次",
          value: 17
        },
        {
          label: "六小时一次",
          value: 18
        },
        {
          label: "八小时一次",
          value: 19
        },
        {
          label: "12小时一次",
          value: 20
        },
        {
          label: "其他",
          value: 21
        }
      ],
      // 疼痛强度
      painIntensityList: [
        {
          label: "0级",
          value: "0级"
        },
        {
          label: "1级",
          value: "1级"
        },
        {
          label: "2级",
          value: "2级"
        },
        {
          label: "3级",
          value: "3级"
        },
        {
          label: "4级",
          value: "4级"
        },
        {
          label: "5级",
          value: "5级"
        },
        {
          label: "6级",
          value: "6级"
        },
        {
          label: "7级",
          value: "7级"
        },
        {
          label: "8级",
          value: "8级"
        },
        {
          label: "9级",
          value: "9级"
        },
        {
          label: "10级",
          value: "10级"
        }
      ],
      // 工业毒物接触频度
      poisonsContactFrequencyList: [
        {
          label: "长期",
          value: 1
        },
        {
          label: "短期",
          value: 2
        },
        {
          label: "偶尔",
          value: 3
        }
      ],
      // 性生活频率
      sexualLifeFrequencyList: [
        {
          label: "每日一次",
          value: 1
        },
        {
          label: "每日两次",
          value: 2
        },
        {
          label: "每日三次",
          value: 3
        },
        {
          label: "每日四次",
          value: 4
        },
        {
          label: "隔日一次",
          value: 5
        },
        {
          label: "隔周一次",
          value: 6
        },
        {
          label: "每周一次",
          value: 7
        },
        {
          label: "每周两次",
          value: 8
        },
        {
          label: "每周三次",
          value: 9
        },
        {
          label: "每两周一次",
          value: 10
        },
        {
          label: "每三周一次",
          value: 11
        },
        {
          label: "每四周一次",
          value: 12
        },
        {
          label: "其他",
          value: 13
        }
      ],
      frozenEmbryoCycleTypeList: [
        {
          label: "自然周期",
          value: 1
        },
        {
          label: "人工周期",
          value: 2
        }
      ],
      // 日期选择器时间范围选择
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() ||
            time.getTime() < new Date("1949-01-01 00:00:00").getTime()
          );
        }
      },
      ifPelvicPainHistorys: "",
      drawer: false,
      // 其他系统疾病列表
      otherDiseaseList: [],
      womenDiseaseList: [],
      geneticDiseaseList: [],
      loading: false,
      threeMonthsWeightStatus: "+", // 近三月内体重变化标识
      diseaseList: [],
      therapyStageList: [],
      flag1: true,
      flag2: true,
      // options: [
      //   {
      //     value: "zhinan",
      //     label: "指南",
      //     children: [
      //       {
      //         value: "shejiyuanze",
      //         label: "设计原则"
      //       },
      //       {
      //         value: "daohang",
      //         label: "导航"
      //       }
      //     ]
      //   },
      //   {
      //     value: "zujian",
      //     label: "组件",
      //     children: [
      //       {
      //         value: "basic",
      //         label: "Basic"
      //       },
      //       {
      //         value: "form",
      //         label: "Form"
      //       },
      //       {
      //         value: "data",
      //         label: "Data"
      //       },
      //       {
      //         value: "notice",
      //         label: "Notice"
      //       },
      //       {
      //         value: "navigation",
      //         label: "Navigation"
      //       },
      //       {
      //         value: "others",
      //         label: "Others"
      //       }
      //     ]
      //   },
      //   {
      //     value: "ziyuan",
      //     label: "资源",
      //     children: [
      //       {
      //         value: "axure",
      //         label: "Axure Components"
      //       },
      //       {
      //         value: "sketch",
      //         label: "Sketch Templates"
      //       },
      //       {
      //         value: "jiaohu",
      //         label: "组件交互文档"
      //       }
      //     ]
      //   }
      // ],
      testTubeUrl: "",
      showLargePic: false,
      dieaseCurrent: 1,
      dieasePages: 0
    };
  },
  computed: {
    getUserDetailsData() {
      return this.getDataDetail(this.userDetailsData);
    }
  },
  mounted() {
    if (this.currentActive === "basicP") {
      this.drawer = true;
      this.isEdit = false;
      this.ruleForm1 = this.getDataDetail(this.userDetailsData);
      // 获取患者关注病种
      this.getFollowingDiseaseName();
    } else {
      this.drawer = false;
      this.isEdit = true;
    }
  },
  watch: {
    currentActive(val) {
      if (val === "basicP") {
        this.drawer = true;
        this.isEdit = false;
        this.ruleForm1 = this.getDataDetail(this.userDetailsData);
        // 获取患者关注病种
        this.getFollowingDiseaseName();
      } else {
        this.drawer = false;
        this.isEdit = true;
      }
    },
    userDetailsData(val) {
      return this.getDataDetail(val);
    },
    jargonList: {
      handler(val) {},
      deep: true,
      immediate: true
    }
  },
  methods: {
    getUpTime(){ 
       this.$emit("userEdit", 1);
    },
    async getDieaseItemList(current, searchCondition) {
      let res = await findDiseaseTypeByAdmin({
        current: current,
        size: 20,
        conditionName: searchCondition
      });
      if (res.code == 0) {
        res.data.records.map(v => {
          v.diseaseId = v.id;
          v.diseaseName = v.suborderName;
        });
        this.diseaseList = this.diseaseList.concat(res.data.records);
        this.dieasePages = res.data.pages;
      }
    },
    //获取检验项目
    loadmore() {
      this.dieaseCurrent++;

      if (this.dieaseCurrent > this.dieasePages) {
        return;
      }
      this.getDieaseItemList(this.dieaseCurrent, this.itemQuery);
      // this.getMergeLeveList();
    },
    remoteDieaseItemMethod(query) {
      this.diseaseList = [];
      this.dieaseCurrent = 1;
      if (query !== "") {
        this.itemQuery = query;
        this.getDieaseItemList(1, query);
      } else {
        this.diseaseList = [];
      }
    },
    bigPicClick(url) {
      this.testTubeUrl = url;
      this.showLargePic = true;
    },
    changeTther() {
      let end = this.$refs.therCascader.getCheckedNodes()[0];
      if (end.level == 1) {
        this.ruleForm1.firstTherapyStageId = end.value;
        this.ruleForm1.firstTherapyStageName = end.label;
        this.ruleForm1.secondTherapyStageId = "";
        this.ruleForm1.secondTherapyStageName = "";
      } else {
        this.ruleForm1.secondTherapyStageId = end.value;
        this.ruleForm1.secondTherapyStageName = end.label;
        this.ruleForm1.firstTherapyStageId = end.parent.value;
        this.ruleForm1.firstTherapyStageName = end.parent.label;
      }
    },

    infoEdit2() {
      if (!this.isEdit) {
        this.diseaseList = [];
        this.dieaseCurrent = 1;
        this.dieasePages = 0;
        // this.getDiseaseList();
        this.getDieaseItemList(1, this.ruleForm1.diseaseName);
        if (this.ruleForm1.diseaseId) {
          this.ruleForm1.diseaseObj = {
            diseaseId: this.ruleForm1.diseaseId,
            diseaseName: this.ruleForm1.diseaseName
          };
          this.getTherapyStageList(this.ruleForm1.diseaseId);
        }
      }
      this.isEdit = !this.isEdit;
    },
    // 获取当前患者关注病种
    async getFollowingDiseaseName() {
      let { code, data } = await getFollowingListByPatient({
        patientId: this.$route.query.patientId
      });
      if (code === 0) {
        this.followingDiseaseName = data.name;
      }
    },
    diseaseNameChange(value) {
      // 获取治疗阶段
      this.ruleForm1.therapyStage = "";
      this.ruleForm1.therapyStageId = "";
      this.ruleForm1.firstTherapyStageId = "";
      this.ruleForm1.firstTherapyStageName = "";
      this.ruleForm1.secondTherapyStageId = "";
      this.ruleForm1.secondTherapyStageName = "";
      this.getTherapyStageList(value.diseaseId);
    },
    // 获取战略病种治疗阶段
    async getTherapyStageList(diseaseId) {
      let { code, data } = await getTherapyStageByDiseaseId({ diseaseId });
      if (code == 0) {
        this.therapyStageList = data
          ? data.map(item => {
              if (item.children && item.children.length == 0) {
                item.children = null;
              }
              if (item.children && item.children.length > 0) {
                item.children.map(items => {
                  if (items.children && items.children.length == 0) {
                    items.children = null;
                  }
                });
              }
              if (item.therapyStageName === this.ruleForm1.therapyStage) {
                this.ruleForm1.therapyStageObj = item;
              }
              return item;
            })
          : [];
      }
    },
    // 关闭抽屉式弹框
    handleClose() {
      this.$emit("closeDrawer", "");
    },
    badHabitsChange() {
      if (this.ruleForm1.assistedReproductionVO.badHabits.indexOf("无") > -1) {
        this.ruleForm1.assistedReproductionVO.badHabits = ["无"];
      }
    },
    abnormalContactHistoryChange() {
      if (
        this.ruleForm1.assistedReproductionVO.abnormalContactHistory.indexOf(
          "无"
        ) > -1
      ) {
        this.ruleForm1.assistedReproductionVO.abnormalContactHistory = ["无"];
      }
    },
    getDataDetail(value) {
      if (!value) return false;
      this.showFlag = true;
      value.assistedReproductionVO = value.assistedReproductionVO
        ? value.assistedReproductionVO
        : this.ruleForm1.assistedReproductionVO;
      const assistedReproductionVO = value.assistedReproductionVO;
     
      if (JSON.stringify(assistedReproductionVO) !='{}') { 
        if (!Array.isArray(assistedReproductionVO.badHabits)) {
          assistedReproductionVO.badHabits = assistedReproductionVO.badHabits
            ? assistedReproductionVO.badHabits.split(";")
            : [];
        }

        if (!Array.isArray(assistedReproductionVO.abnormalContactHistory)) {
          assistedReproductionVO.abnormalContactHistory = assistedReproductionVO.abnormalContactHistory
            ? assistedReproductionVO.abnormalContactHistory.split(";")
            : [];
        }

        if (!Array.isArray(assistedReproductionVO.otherDiseaseName)) {
          assistedReproductionVO.otherDiseaseName = assistedReproductionVO.otherDiseaseName
            ? assistedReproductionVO.otherDiseaseName.split(";")
            : [];
        }

        if (!Array.isArray(assistedReproductionVO.womenDiseaseName)) {
          assistedReproductionVO.womenDiseaseName = assistedReproductionVO.womenDiseaseName
            ? assistedReproductionVO.womenDiseaseName.split(";")
            : [];
        }

        if (!Array.isArray(assistedReproductionVO.geneticDiseaseName)) {
          assistedReproductionVO.geneticDiseaseName = assistedReproductionVO.geneticDiseaseName
            ? assistedReproductionVO.geneticDiseaseName.split(";")
            : [];
        }

        this.threeMonthsWeightStatus =
          assistedReproductionVO.threeMonthsWeight > 0
            ? "+"
            : assistedReproductionVO.threeMonthsWeight < 0
            ? "-"
            : "";

        assistedReproductionVO.threeMonthsWeight = Math.abs(
          assistedReproductionVO.threeMonthsWeight
            ? assistedReproductionVO.threeMonthsWeight
            : 0
        );
        assistedReproductionVO.intrapartumComplications = assistedReproductionVO.intrapartumComplications
          ? assistedReproductionVO.intrapartumComplications
          : "";

        Object.keys(this.ruleForm1.assistedReproductionVO).forEach(item => {
          if (this.userDetailsData.assistedReproductionVO) {
            this.ruleForm1.assistedReproductionVO[item] =
              this.userDetailsData.assistedReproductionVO[item] || "";
          }
        });
      }
      Object.keys(this.ruleForm1).forEach(item => { 
        if(item !='assistedReproductionVO'){
          this.ruleForm1[item] = this.userDetailsData[item] || "";
        }else{ 
          if(JSON.stringify(this.userDetailsData[item]) !='{}'){
            this.ruleForm1[item] = this.userDetailsData[item] || ""; 
          }
        } 
      });  
      // mmmmm
      this.therapyStageIdList = [];
      if (
        this.userDetailsData.therapyStageInfo &&
        this.userDetailsData.therapyStageInfo.length > 0
      ) {
        let end = this.userDetailsData.therapyStageInfo[0];
        this.therapyStageIdList.push(end.therapyStageId);
        this.ruleForm1.firstTherapyStageId = end.therapyStageId;
        this.ruleForm1.firstTherapyStageName = end.therapyStageName;
        if (end.child && end.child.therapyStageId) {
          this.therapyStageIdList.push(end.child.therapyStageId);
          this.ruleForm1.secondTherapyStageId = end.child.therapyStageId;
          this.ruleForm1.secondTherapyStageName = end.child.therapyStageName;
        }
      } 
      return this.ruleForm1;
    },
    // 是否盆腹腔疼痛史单选切换二次点击可取消选中
    radioCheckChange(props, label) {
      label === this.ruleForm1.assistedReproductionVO[props]
        ? (this.ruleForm1.assistedReproductionVO[props] = "")
        : (this.ruleForm1.assistedReproductionVO[props] = label);
      if (
        props === "ifPelvicPainHistory" &&
        this.ruleForm1.assistedReproductionVO.ifPelvicPainHistory !== 1
      ) {
        this.ruleForm1.assistedReproductionVO.pelvicPainHistory = "";
      }
    },
    // 模糊搜索疾病类型
    remoteMethod(query, list) {
      if (query !== "") {
        this.loading = true;
        getFindIcdDiseaseByCondition({
          conditionName: query
        }).then(res => {
          if (res.code === 0) {
            this.loading = false;
            this[list] = res.data.map(item => {
              return {
                label: item.suborderName,
                value: item.id
              };
            });
          }
        });
      } else {
        this[list] = [];
      }
    },
    // 疾病类型最多可选择10项
    diseaseNameMaxChange(value, props) {
      if (value.length > 10) {
        this.$message.info("最多可选择10项疾病");
        this.ruleForm1.assistedReproductionVO[props].splice(-1);
      }
    },
    // 删除某项异常接触史执行清空操作
    abnormalContactHistoryRemove(val) {
      const assistedReproductionVO = this.ruleForm1.assistedReproductionVO;
      if (val === "工业毒物、粉尘接触") {
        assistedReproductionVO.industrialPoisons = "";
        assistedReproductionVO.exposureDose = "";
        assistedReproductionVO.poisonsContactFrequency = "";
        assistedReproductionVO.contactType = "";
      } else if (val === "放射性物质接触") {
        assistedReproductionVO.radioactiveSource = "";
        assistedReproductionVO.radioactiveSourceFrequency = "";
      } else if (val === "接触过疫水") {
        assistedReproductionVO.infectedWaterContactTime = "";
        assistedReproductionVO.infectedWaterContactAreas = "";
      } else {
        // 疫区
        assistedReproductionVO.epidemicAreaContactTime = "";
        assistedReproductionVO.epidemicAreaContactAreas = "";
      }
    },
    // 辅助生殖新增接口
    submitHandelReproduction() {
      // 盆腹腔疼痛史为是时输入框必填
      const assistedReproductionVO = this.ruleForm1.assistedReproductionVO;
      if (
        assistedReproductionVO.ifPelvicPainHistory === 1 &&
        !assistedReproductionVO.pelvicPainHistory
      ) {
        return this.$message.error("请输入盆腹腔疼痛史");
      }
      // 性生活频率为其他时，其他必填
      if (
        assistedReproductionVO.sexualLifeFrequency === 13 &&
        !assistedReproductionVO.sexualLifeFrequencyOther
      ) {
        return this.$message.error("请输入其他性生活频率");
      }
      // 避孕手段为其他时，其他必填
      if (
        assistedReproductionVO.contraceptionType === 9 &&
        !assistedReproductionVO.contraceptionTypeOther
      ) {
        return this.$message.error("请输入其他避孕手段");
      }
      // 不良嗜好为其他时，其他必填
      if (
        assistedReproductionVO.badHabits.indexOf("其他") > -1 &&
        !assistedReproductionVO.badHabitsOther
      ) {
        return this.$message.error("请输入其他不良嗜好");
      }
      // 闭经为是时，末次月经为必填
      // if (
      //   assistedReproductionVO.isAmenorrhea === 1 &&
      //   !assistedReproductionVO.lastMenstruation
      // ) {
      //   return this.$message.error("请选择末次月经时间");
      // }

      // 不良嗜好异常接触史数据转换
      if (this.isEdit) {
        // 辅助生殖时id不传
        if (
          this.threeMonthsWeightStatus &&
          !this.ruleForm1.assistedReproductionVO.threeMonthsWeight
        ) {
          this.$message.error("请查看近三月体重是否填写完整");
          return false;
        }
      }
    },
    // 病历基本信息接口保存
    submitHandelBasic() {
      if (this.isEdit) {
        let jargonList = this.jargonList.map(item => {
          return {
            id: item.id,
            patientId: item.patientId,
            value: item.value
          };
        });
        if (this.ruleForm1.isAssistedReproduction === 1) {
          // 盆腹腔疼痛史为是时输入框必填
          const assistedReproductionVO = this.ruleForm1.assistedReproductionVO;
          if (
            assistedReproductionVO.ifPelvicPainHistory === 1 &&
            !assistedReproductionVO.pelvicPainHistory
          ) {
            return this.$message.error("请输入盆腹腔疼痛史");
          }
          // 性生活频率为其他时，其他必填
          if (
            assistedReproductionVO.sexualLifeFrequency === 13 &&
            !assistedReproductionVO.sexualLifeFrequencyOther
          ) {
            return this.$message.error("请输入其他性生活频率");
          }
          // 避孕手段为其他时，其他必填
          if (
            assistedReproductionVO.contraceptionType === 9 &&
            !assistedReproductionVO.contraceptionTypeOther
          ) {
            return this.$message.error("请输入其他避孕手段");
          }
          // 不良嗜好为其他时，其他必填
          if (
            assistedReproductionVO.badHabits.indexOf("其他") > -1 &&
            !assistedReproductionVO.badHabitsOther
          ) {
            return this.$message.error("请输入其他不良嗜好");
          }
          // 闭经为是时，孕前末次月经为必填
          if (
            assistedReproductionVO.isAmenorrhea === 1 &&
            !assistedReproductionVO.lastMenstruation
          ) {
            return this.$message.error("请选择绝经时间");
          }

          // 不良嗜好异常接触史数据转换
          if (this.editInfo2) {
            // 辅助生殖时id不传
            if (
              this.threeMonthsWeightStatus &&
              !this.ruleForm1.assistedReproductionVO.threeMonthsWeight
            ) {
              this.$message.error("请查看近三月体重是否填写完整");
              return false;
            }
          }
        }
        const param = {
          ...this.ruleForm1.assistedReproductionVO,
          abnormalContactHistory: this.ruleForm1.assistedReproductionVO.abnormalContactHistory.join(
            ";"
          ),
          badHabits: this.ruleForm1.assistedReproductionVO.badHabits.join(";"),
          otherDiseaseName: this.ruleForm1.assistedReproductionVO.otherDiseaseName.join(
            ";"
          ),
          womenDiseaseName: this.ruleForm1.assistedReproductionVO.womenDiseaseName.join(
            ";"
          ),
          geneticDiseaseName: this.ruleForm1.assistedReproductionVO.geneticDiseaseName.join(
            ";"
          ),
          threeMonthsWeight:
            this.threeMonthsWeightStatus +
            this.ruleForm1.assistedReproductionVO.threeMonthsWeight,
          archivesId: this.ruleForm1.id,
          patientId: this.ruleForm1.patientId
        };

        let paramsForm = DEEP_CLONE(this.ruleForm1);
        paramsForm.patientArchivesAssistedReproductionDTO = param;
        delete paramsForm.assistedReproductionVO;
        Promise.all([
          UpdatepatientArchiesRight({
            ...paramsForm,
            diseaseId: this.ruleForm1.diseaseObj.diseaseId,
            diseaseName: this.ruleForm1.diseaseObj.diseaseName,
            // therapyStage: this.ruleForm1.therapyStageObj.therapyStageName,
            // therapyStageId: this.ruleForm1.therapyStageObj.therapyStageId,
            isAssistedReproduction:
              this.ruleForm1.isAssistedReproduction === 1 ? 1 : 2
          }),
          terminologyMultipleInsert(jargonList)
        ])
          .then(res => {
            this.$message.success("修改成功");
            this.$emit("userEdit", 1);
            this.isEdit = false;
          })
          .catch(error => {
            this.$message({
              type: "error",
              message: error.message
            });
            this.loading = false;
          });
      }
    },
    /**
     * @description: 保存按钮
     * @param {*}
     * @return {*}
     */
    submitHandel() {
      // 试管编号校验
      if (
        this.ruleForm1.testTubeNumber &&
        this.ruleForm1.testTubeNumber.length < 6
      ) {
        this.$message.error("请输入正确试管编号");
        return;
      }
      if (
        this.ruleForm1.testTubeNumber &&
        !/^\d{1,}$/.test(this.ruleForm1.testTubeNumber)
      ) {
        this.$message.error("请填写大于等于0的数字");
        return;
      }
      if (this.ruleForm1.testTubeNumber && !this.ruleForm1.testTubeDate) {
        this.$message.error("请选择试管日期");
        return;
      }
      if (!this.ruleForm1.testTubeNumber && this.ruleForm1.testTubeDate) {
        this.$message.error("请填写试管编号");
        return;
      }
      if(this.ruleForm1.assistedReproductionVO.frozenEmbryoCount &&
          !/^(?:[1-9]\d*|0)$/.test(this.ruleForm1.assistedReproductionVO.frozenEmbryoCount)){
          this.$message.error("请输入正确的冻胚数量");
          return;
      }
      this.submitHandelBasic();
    },
    // 避孕手段转换
    translateContraceptionType(type) {
      let label = "";
      this.contraceptionTypeList.forEach(item => {
        if (item.value === type) label = item.label;
      });
      return label;
    },
    // 疼痛发作频率
    translatePainFrequency(type) {
      let label = "";
      this.painFrequencyList.forEach(item => {
        if (item.value === type) label = item.label;
      });
      return label;
    },
    // 性生活频率
    translateSexualLifeFrequency(type) {
      let label = "";
      this.sexualLifeFrequencyList.forEach(item => {
        if (item.value === type) label = item.label;
      });
      return label;
    },
    slideClick1() {
      this.flag1 = !this.flag1;
    },
    slideClick2() {
      this.flag2 = !this.flag2;
    },
    handleChange(value) {
      console.log(value);
    }
  }
};
</script>
<style scoped lang="less">
@import "./index.less";
/deep/.aside .el-form-item .el-select {
  width: 190px !important;
  height: 30px !important;
}
/deep/.el-textarea__inner {
  width: 306px !important;
  height: 66px !important;
}
/deep/.el-input-group--append .el-input__inner {
  width: 230px !important;
  height: 32px !important;
}
/deep/.aside .el-form-item .el-input {
  width: 280px !important;
}
/deep/.aside .el-form-item .select-box {
  width: 180px !important;
}
/deep/.aside .el-form-item .select-box .el-input {
  width: 180px !important;
}
/deep/.aside .el-form-item .select-box .el-input__inner {
  width: 175px !important;
  height: 32px !important;
}
</style>

<style lang="less">
.basic-p-drawer {
  padding: 10px 24px;
  height: calc(100% - 72px);
  background: #fff;
  .bad-habit {
    padding: 2px 6px;
    border-radius: 11px;
    background: #eff6ff;
    color: #1a7bfc;
    margin-right: 20px;
  }
  .edit {
    .el-row {
      margin-bottom: 10px;
    }
  }
  .birthDefectedChildren {
    .el-form-item__label {
      line-height: 14px;
    }
  }
  .link-box{
    width: 420px;
  }
}
.ruleForm-title {
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 28px 0 16px;
  cursor: pointer;
  .ruleForm-title-left {
    display: flex;
    align-items: center;
    .span-title {
      display: inline-block;
      width: 4px;
      height: 15px;
      background: #1a7bfc;
      margin: 0 10px 0 0;
    }
    .span-text {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
    }
  }
  // .ruleForm-title-right {
  //   display: flex;
  //   align-items: center;

  //   .span-title {
  //     font-size: 12px;
  //     font-family: PingFangSC-Regular, PingFang SC;
  //     font-weight: 400;
  //     color: #333333;
  //     line-height: 18px;
  //   }
  //   img {
  //     width: 16px;
  //     height: 16px;
  //     margin: 0 0 0 6px;
  //   }
  // }
} 
.basic-p-drawer .chain-item {
  width: 420px!important;
  display: flex;
  align-items: center; 
  p {
    width: 80px;
    margin-right: 60px;
  }
  a {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1a7bfc;
    line-height: 28px;
  }
  .edite-record {
    display: flex;
    align-items: center;
    .record {
      font-size: 12px;
      display: flex;
      align-items: center;
      margin-left: 28px;
      color: #1a7bfc;
      cursor: pointer;
      user-select: none;
    }
    .icon-arrow {
      font-weight: bold;
      font-size: 14px;
      margin-left: 5px;
    }
  }
}
</style>